import classNames from 'classnames';
import styles from './NetworkVariationIndicator.module.scss';

type NetworkVariationIndicatorProps = { value: number | null; suffix?: string };
const variationFormatter = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1, signDisplay: 'always' });

export const NetworkVariationIndicator = ({ value, suffix = '' }: NetworkVariationIndicatorProps) => {
  if (value === null || !Number.isFinite(value)) return <span className={styles.placeholder}>--</span>;
  if (value === 0) return <span className={styles.box}>SEM VAR.</span>;

  return (
    <span className={classNames(styles.box, value > 0 ? styles.positive : styles.negative)}>
      {variationFormatter.format(value)}
      {suffix}
    </span>
  );
};
